import { render, staticRenderFns } from "./TooltipBig.vue?vue&type=template&id=1d0858b7&scoped=true&"
import script from "./TooltipBig.vue?vue&type=script&lang=js&"
export * from "./TooltipBig.vue?vue&type=script&lang=js&"
import style0 from "./TooltipBig.vue?vue&type=style&index=0&id=1d0858b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0858b7",
  null
  
)

export default component.exports